import React, { useState } from 'react'
import ImageField from '../../../customs/ImageField';
import Input from '../../../customs/Input';

export default function DynamicAdOns({ day, handleChangeInput }) {
    const [addOns, setaddOns] = useState([
        {
            add_on: "",
            add_on_price: "",
            add_on_image: "",
        },
    ]);

    const addInputFields = () => {
        setaddOns([...addOns, { add_on: "", add_on_price: "", add_on_image: "" }]);
    };

    const handleRemoveClicked = (index) => {
        const values = [...addOns];
        values.splice(index, 1);
        setaddOns(values);
    };

    return (
        addOns.map((inputfield, index) => (
            <div className="row mt-2 " key={index}>
                <div className="col-3">
                    <Input
                        label="Add on"
                        name="add_on"
                        type="text"
                        handler={(e) => handleChangeInput(index, e)}
                        required={false}
                    />
                    <Input
                        label="price"
                        name="add_on_price"
                        type="text"
                        handler={(e) => handleChangeInput(index, e)}
                        required={false}
                    />
                </div>
                <div className='col-7 px-0' style={{ marginTop: -10 }}>
                    <ImageField
                        title="Add On Image"
                        name="add_on_image"
                        id={`image-${index}`}
                        accepts={[".jpeg", ".png", ".jpg"]}
                        minSize="240 x 240"
                    />
                </div>

                <div className="col-2 px-0">
                    <div className="form-inline mt-4 py-2">
                        <button
                            type="button"
                            className="btn btn-default mr-2"
                            onClick={(event) => addInputFields(event)}
                        >
                            <i className="fa fa-plus" />
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => handleRemoveClicked(index)}
                        >
                            <i className="fa fa-trash-o" />
                        </button>
                    </div>
                </div>
            </div>
        ))

    )
}
